import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useEnglishText } from "../../../text/useEnglishText.js";

import DocumentsTabs from "../../../components/ui/DocumentsTabs";
import RolesPermissionsTab from "../../../components/app/settings/RolesPermissionsTab";
import AppearanceTab from "../../../components/app/settings/AppearanceTab";
import AdminPageHeader from "../../../components/common/AdminPageHeader";
import { Settings2 } from "lucide-react";

import "../../../styles/Settings.css";
import "../../../styles/Profile.css";

const TABS = [
  { value: "ROLES", label: "Roles" },
  { value: "APPEARANCE", label: "Appearance" },
];

export default function SettingsPage() {
  const { t } = useEnglishText();
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab")?.toUpperCase();
  const [activeTab, setActiveTab] = useState(requestedTab === "APPEARANCE" ? "APPEARANCE" : "ROLES");

  useEffect(() => {
    setActiveTab(requestedTab === "APPEARANCE" ? "APPEARANCE" : "ROLES");
  }, [requestedTab]);

  const handleChange = (tab) => {
    setActiveTab(tab);
    const next = new URLSearchParams(searchParams);
    if (tab === "APPEARANCE") next.set("tab", "appearance");
    else next.delete("tab");
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="profile-page settings-page">
      <AdminPageHeader icon={Settings2} title={t("settings.title")} description={t("settings.subtitle")} />

      <DocumentsTabs active={activeTab} onChange={handleChange} tabs={TABS} />

      <div className="settings-content">
        {activeTab === "ROLES" && <RolesPermissionsTab />}
        {activeTab === "APPEARANCE" && <AppearanceTab />}
      </div>
    </div>
  );
}
